module.exports = __webpack_public_path__ + "img/icn_close_modal.5a3816cc.svg";